import { SiteData } from './site-data';
import { CHAT_DEF_ID } from '../constants/branding';
import _isEmpty from 'lodash/isEmpty';

export const siteDataFromSiteJson = (siteJson: SiteJson): SiteData => {
  if (_isEmpty(siteJson)) {
    return {};
  }

  const widgetId =
    Object.keys(siteJson.pages.masterPage.widgetComponents).pop() || '';
  const widget = siteJson.pages.masterPage.widgetComponents[widgetId] || {
    style: {},
    data: {},
  };

  const appDate =
    siteJson.applications && siteJson.applications[CHAT_DEF_ID]
      ? siteJson.applications[CHAT_DEF_ID].appData
      : {};

  return {
    styleParams: {
      colors: widget.style.colors,
      fonts: { ...widget.style.fonts, ...widget.style.unstructuredFonts },
      booleans: widget.style.booleans,
    },
    siteColors: siteJson.siteColors,
    publicData: { ...appDate, ...widget.data },
  };
};
